import Banner from "./Component/Banner/Banner";
import TextBox from "./Component/TextBox/TextBox";
import UploadImage from "./Component/UploadImage/UploadImage";
import {
  ReportDumpingFormWrapper,
  ReportDumpingWrapper,
  ReportDumpingRightFormWrapper,
  ReportDumpingTextField,
  ReportDumpingSendButtonWrapper,
  ReportDumpingSendButton,
} from "./ReportDumpingStyled";

const ReportDumping = () => {
  return (
    <ReportDumpingWrapper>
      <Banner />
      <ReportDumpingFormWrapper>
        <UploadImage />
        <ReportDumpingRightFormWrapper>
          <ReportDumpingTextField label="Distributor ID or Name" />
          <TextBox />
        </ReportDumpingRightFormWrapper>
      </ReportDumpingFormWrapper>
      <ReportDumpingSendButtonWrapper>
        <ReportDumpingSendButton>SEND</ReportDumpingSendButton>
      </ReportDumpingSendButtonWrapper>
    </ReportDumpingWrapper>
  );
};

export default ReportDumping;
